/* @ngInject */
function connectorWebService ($cookies, $http, $q, $window, $rootScope, $location, LanguageService, RollbarService) {
  var oConnectorWebService = {}

  /**
   * @returns {void}
   * @param {string} sUrl
   * @param {string} method
   * @param {Object} oData
   * @param {Object} mCustomHeaders
   * @param {Object} listeners
   * @param {Object} options
   * @param {boolean} options.externalUrl
   */
  oConnectorWebService.createCustomXHR = function (sUrl, method, oData, mCustomHeaders, listeners, options) {
    var oReq = new $window.XMLHttpRequest()
    var request = $q(function (resolve, reject) {
      oReq.open(method || 'GET', sUrl)

      if (mCustomHeaders.responseType) {
        oReq.responseType = mCustomHeaders.responseType
        delete mCustomHeaders.responseType
      } else {
        oReq.responseType = 'json'
      }

      var oHeaders = mCustomHeaders || {}
      oHeaders['Accept-Language'] = LanguageService.getLanguage()

      if (!options?.removeAuthHeader) {
        oHeaders.Authorization = 'Bearer ' + $cookies.get('jwt')
      }

      if (options && options.externalUrl) {
        oHeaders = {}
      }

      Object.keys(oHeaders).forEach(function (header) {
        oReq.setRequestHeader(header, oHeaders[header])
      })

      if (!listeners.load) {
        oReq.addEventListener('load', function (evt) {
          if (options && options.returnContext) {
            resolve(this)
          }
          resolve(this.response)
        })
      }
      if (!listeners.error) {
        oReq.addEventListener('error', function (evt) {
          reject(this.statusText)
        })
      }

      Object.keys(listeners).forEach(function (event) {
        var vValue = listeners[event]
        if (typeof vValue === 'object') {
          return Object.keys(vValue).forEach(function (innerEvent) {
            oReq[event].addEventListener(innerEvent, vValue[innerEvent])
          })
        }
        if (event === 'load') {
          return oReq.addEventListener(event, listeners[event](resolve, reject))
        }
        return oReq.addEventListener(event, listeners[event])
      })

      oReq.send(oData)
    })

    request.abort = function abort () {
      oReq.abort()
      request.reject('Request aborted')
    }

    return request
  }

  oConnectorWebService.put = function (sServiceUrl, oData, mCustomHeaders) {
    var oHeaders = mCustomHeaders || {}
    oHeaders['Accept-Language'] = LanguageService.getLanguage()
    oHeaders.Authorization = 'Bearer ' + $cookies.get('jwt')

    return $http.put(sServiceUrl, oData, {
      headers: oHeaders
    })
      .then(
        function success (response) {
          return response.data
        },
        function error (response) {
          if (response.status === 500) {
            RollbarService.error(response, response.data)
          }

          _validateUserUnauthorized({
            statusCode: response.status,
            errorCode: response.data.code
          })
          return $q.reject(response)
        }
      )
  }

  oConnectorWebService.post = function (sServiceUrl, oData, mCustomHeaders) {
    var oHeaders = mCustomHeaders || {}
    oHeaders['Accept-Language'] = LanguageService.getLanguage()
    oHeaders.Authorization = 'Bearer ' + $cookies.get('jwt')

    return $http.post(sServiceUrl, oData, {
      dataType: 'json',
      headers: oHeaders
    })
      .then(
        function success (response) {
          return response.data
        },
        function error (response) {
          if (response.status === 500) {
            RollbarService.error(response, response.data)
          }

          _validateUserUnauthorized({
            statusCode: response.status,
            errorCode: response.data.code
          })
          return $q.reject(response)
        }
      )
  }

  oConnectorWebService.get = function (sServiceUrl, mCustomHeaders, bExternalUrl) {
    const bExternal = bExternalUrl || false
    var oHeaders = mCustomHeaders || {}
    oHeaders['Accept-Language'] = LanguageService.getLanguage()
    oHeaders.Authorization = 'Bearer ' + $cookies.get('jwt')

    if (bExternal) {
      return jQuery.ajax(sServiceUrl)
    }

    return $http.get(sServiceUrl, {
      headers: oHeaders
    })
      .then(
        function success (response) {
          return response.data
        },
        function error (response) {
          if (response.status === 500) {
            RollbarService.error(response, response.data)
          }

          _validateUserUnauthorized({
            statusCode: response.status,
            errorCode: response.data.code
          })
          return $q.reject(response)
        }
      )
  }

  oConnectorWebService.fnDelete = function (sServiceUrl, mCustomHeaders, options = {}) {
    var oHeaders = mCustomHeaders || {}
    oHeaders['Accept-Language'] = LanguageService.getLanguage()
    oHeaders.Authorization = 'Bearer ' + $cookies.get('jwt')

    const deleteRequestHandler = () => [
      function success (response) {
        return response.data
      },
      function error (response) {
        if (response.status === 500) {
          RollbarService.error(response, response.data)
        }

        _validateUserUnauthorized({
          statusCode: response.status,
          errorCode: response.data.code
        })
        return $q.reject(response)
      }
    ]

    if (options.keepalive) {
      return fetch(sServiceUrl, {
        method: 'delete',
        keepalive: true,
        headers: oHeaders
      }).then(...deleteRequestHandler())
    }

    return $http.delete(sServiceUrl, {
      headers: oHeaders
    })
      .then(...deleteRequestHandler())
  }

  function _validateUserUnauthorized (params) {
    const { statusCode, errorCode } = params
    const publicStates = [
      '/login',
      '/signup',
      '/rememberPassword',
      '/inactive',
      '/unauthorized',
      '/recoverPassword',
      '/user/verification',
      '/login/sso',
      '/arts/download',
      '/welcome',
      '/onboarding',
      '/twoFactorVerification',
      '/updatePassword',
      '/guest/login',
      '/guest/resendPassword',
      '/email-confirmation',
      '/arts/folder'
    ]
    const isPublicState = publicStates.some(state => $location.path().startsWith(state))

    if (isPublicState) {
      return
    }

    if (statusCode && statusCode === 401) {
      $rootScope.$emit('MobileTokenExpired', { errorCode })
    }
  }

  return oConnectorWebService
}

export { connectorWebService }
